import { getCvObj } from '../../../../Maker/F/Fcanvas/cv_object.js';
import { create } from './create.js';

export const add = (fcanvas, safety) => {
  const last_cv_obj = getCvObj(fcanvas._objects, 'cv_safety_area');
  if (last_cv_obj) fcanvas.remove(last_cv_obj);
  if (!safety) return;
  fcanvas.add(create(safety));
};
